import { find, keys } from 'lodash/fp';

export function rewritePath(rewriteRules = {}) {
  return path => {
    const matchingPattern = find(
      pattern => new RegExp(`^${pattern}(\\/|$)`).test(path),
      keys(rewriteRules)
    );

    if (matchingPattern) {
      return path.replace(matchingPattern, rewriteRules[matchingPattern]);
    }

    return path;
  };
}

export function findSection({ rewriteRules = {} }) {
  const rewrite = rewritePath(rewriteRules);

  const sections = [
    { path: '/lobby', name: 'Lobby', exact: true },
    { path: rewrite('/my-challenges'), name: 'My Challenges', exact: true },
    { path: rewrite('/live-challenges'), name: 'Live Challenges', exact: true },
    { path: '/account/history', name: 'History', exact: true },
    { path: '/training', name: 'Training', exact: true },
    { path: '/ultimate-champion', name: 'Ultimate Champion' }
  ];

  return pathname =>
    sections.find(s => (s.exact ? s.path === pathname : pathname.startsWith(s.path)));
}
